module.exports = __webpack_public_path__ + "static/assets/0e92716afebebbcf027802e341220ca0.png";